export default "/icon-arrow-up-right.svg";